export default __webpack_public_path__ + "static/media/product-groups.85f920c9.svg";